// Components==============
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { ResultsEntity } from "typings/Database/Results";
// =========================

export const getResults = async () => {
  const { data } = await axios.get("/api/results");
  return data as ResultsEntity[];
};

export default function useGetResults(
  options?: UseQueryOptions<ResultsEntity[]>
) {
  const query = useQuery<ResultsEntity[]>({
    queryKey: ["results"],
    queryFn: getResults,
    ...options,
  });

  return query;
}
